import {SalaryHeadsList} from "./SalaryHeadsList";
import {SalaryHeadsEdit} from "./SalaryHeadsEdit";
import {SalaryHeadsCreate} from "./SalaryHeadsCreate";

export default {
    list: SalaryHeadsList,
    create: SalaryHeadsCreate,
    edit: SalaryHeadsEdit
};
